
import { Observable,  of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Customer } from '../models/customer';
import { catchError, retryWhen } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OktaConfiguration } from '../models/okta-configuration';
import { api, handleError, retryStrategy } from '../../shared/api-loaders';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class CustomerService {

  constructor(private http: HttpClient, private _http: HttpClient) { }

  getCustomers(): Observable<Customer[]> {
    return this._http
      .get(api.customers()).pipe(
      catchError(handleError),);
  }

  getCustomersByStack(): Observable<Customer[]> {
    return this._http
      .get(api.customersByStack()).pipe(
        catchError(handleError),);
  }

  /** GET */
  getCustomer(id: number): Observable<Customer> {
    return this._http
      .get(api.customer(id)).pipe(
      catchError(handleError),);
  }

  /** PUT */
  updateCustomer(id: number, customer: Customer): Observable<Customer> {
    return this._http
      .put(api.customer(id), customer,).pipe(
      catchError(handleError),);
  }

  /** POST */
  addCustomer (customer: Customer): Observable<Customer> {
    return this._http
      .post(api.customers(), customer).pipe(
      catchError(handleError),);
  }

  /** DELETE */
  deleteCustomer (id: number): Observable<Customer> {
    return this._http
      .delete(api.customer(id)).pipe(
      catchError(handleError));
  }

  /** GET */
  getCustomerDefaultConfigCount(id: number): Observable<string> {
    return this._http
      .get(api.getCustomerDefaultConfigCount(id)).pipe(
        catchError(handleError),);
  }


  /** GET Customer Parameters*/
  getParameters(customerId: number) {
    return this._http
      .get<any[]>(api.getCustomerParameters(customerId))
       .pipe(retryWhen(retryStrategy()));
  }
   /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the MessageService */
  private log(message: string) {
    console.log(`customer.service: ${message}`);
  }

  getCustomerOktaDetails(crmId) {
    const crmIdString = crmId.toString();
    return this.http.get<OktaConfiguration>(api.getOktaShellDetails(crmIdString)).pipe(retryWhen(retryStrategy()));
  }

  generateCustomerOktaDetails(data: OktaConfiguration) {
    return this.http.post(api.postOktaShellDetails(), data).pipe(retryWhen(retryStrategy()));
  }
  /** POST Customer GUID*/
  customerGuidSync(crmId : string): Observable<string> {
    return this._http
      .post(api.customerGuidSync(crmId), null).pipe(
        catchError(handleError));
  }

  /** GET Customer Parameters*/
  getCorporateStructureByConfigId(configId: string): Observable<any[]> {
    return this._http
      .get<any[]>(api.corporateStructureByConfigId(configId))
      .pipe(retryWhen(retryStrategy()));
  }

  /** GET Customer Parameters*/
  getCorporateStructureByCrmId(crmId: string, cacheOnly = false): Observable<any[]> {
    return this._http
      .get<any[]>(api.corporateStructureByCrmId(crmId, cacheOnly))
      .pipe(retryWhen(retryStrategy()));
  }

  /** GET slim configuration summaries (configId, configName, isDefault) — no SNF calls */
  getCustomerConfigurationsByCrmId(crmId: string): Observable<{configId: number, configName: string, isDefault: boolean}[]> {
    return this._http
      .get<{configId: number, configName: string, isDefault: boolean}[]>(api.customerConfigurations(crmId))
      .pipe(retryWhen(retryStrategy()));
  }
}
